module.exports = __webpack_public_path__ + "static/media/KG.d98784ea.svg";